import { StatusChipCombinedProps } from './types';

const usePresenter = (props: StatusChipCombinedProps): StatusChipCombinedProps => {
  return props;
};

export default usePresenter;
